import React, { Component } from 'react';
import Link from 'gatsby-link';
import styled from 'styled-components';
import NavItem from './NavItem';

const Nav = styled.nav`
  font-family: ISOCPEUR;
  padding-bottom: 50px;
`;

const NavSub = styled.nav`
  font-family: ISOCPEUR;
  margin-bottom: 50px;
`;

const List = styled.ul`
  margin: 0;
  text-align: right;
  list-style-type: none;
`;

const ListLeft = styled.ul`
  margin: 0;
  text-align: left;
  padding-left: 0;
  margin-top: -20px;
  list-style-type: none;
`;

const ListItem = styled.li`
  font-size: 12px;
  margin-left: 40px;
  display: inline;
`;

const ListItemLeft = styled.li`
  font-size: 12px;
  margin-right: 40px;
  display: inline;
`;

class Navigation extends Component {
  render() {
    const { navType, items } = this.props;

    if (navType !== 'sub') {
      const ListType = List;
      const ListItemType = ListItem;
      const NavType = Nav;

      return (
        <NavType>
          <ListType>
            {items.map(({ node: item }) => (
              <NavItem type="main" key={item.key} item={item} />
            ))}
          </ListType>
        </NavType>
      );
    } else {
      const ListType = ListLeft;
      const ListItemType = ListItemLeft;
      const NavType = NavSub;

      return (
        <NavType>
          <ListType>
            {items.map(({ node: item }) => {
              return item.subItems.map(
                subitem =>
                  item.sub && (
                    <NavItem type="sub" key={subitem.key} item={subitem} />
                  )
              );
            })}
          </ListType>
        </NavType>
      );
    }
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/componenten/Navigation.js